import React from 'react';
import { Button, Flex, Icon, Link } from '@pega/cosmos-react-core';
import styled, { css } from 'styled-components';

interface DisplayWebhooksProps {
  webhooks: string[];
  editWebhook: any;
  deleteConfirmation: any;
}

const StyledIconButton = {
  marginInlineStart: 0,
};

export const StyledLinkHover = styled.h5(
  () =>
    css`
      :hover {
        text-decoration: underline;
      }
    `,
);

export const linkTextStyle = {
  width: 'fit-content',
  cursor: 'pointer',
  color: '#0076D1',
  fontSize: '0.8125rem',
  paddingRight: '5px',
};

const StyledFlexItem = styled.div(
  (props: any) => css`
  flex: ${props.length > 1 ? '0 0 50%' : '0 0 100%'}; 
  'box-sizing': 'border-box'; 
  padding: 10px;
  `,
);

const DisplayWebhooks: React.FC<DisplayWebhooksProps> = ({ webhooks, editWebhook, deleteConfirmation }) => {
  const length = webhooks.length;
  return (
    <Flex container={{ wrap: 'wrap', pad: 3 }}>
      {webhooks.map((hook, index) => (
        <Flex container={{ direction: 'row', alignItems: 'center' }} key={index} as={StyledFlexItem} length={length}>
          <Link href="" as={StyledLinkHover} style={linkTextStyle}>
            {hook}
          </Link>
          <Button
            variant="simple"
            icon
            style={StyledIconButton}
            onClick={() => {
              editWebhook(index);
            }}
          >
            <Icon name="pencil" />
          </Button>
          <Button
            variant="simple"
            icon
            style={StyledIconButton}
            onClick={() => {
              deleteConfirmation(index);
            }}
          >
            <Icon name="trash" />
          </Button>
        </Flex>
      ))}
    </Flex>
  );
};

export default DisplayWebhooks;
